// libraries
import type { DealHistory } from '@makemydeal/dr-dash-types';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';

// consts
import { GROSS_CAP_COST } from '../../constants';

// components
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useHeldValue } from '../../hooks/useHeldSelector';

const GrossCapCost = ({ deal, hasDelta }: { deal?: DealHistory; hasDelta?: boolean }) => {
    const useDealRootSelector = createDealRootSelector(deal, 'GrossCapCost');
    const capCostTotal = useHeldValue(useDealRootSelector(offerReduxSelectors.getCapCostTotal, 'capCostTotal'), deal);
    const value = formatDollarsAndCents(capCostTotal);
    const { showDetailedView } = useDealSummary();

    return (
        <DealSummaryItem
            hasDelta={hasDelta}
            label={GROSS_CAP_COST}
            value={value}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default GrossCapCost;
